import { cachedHttp } from "./httpService";

const apiEndPoint = "/languages";

function getLanguage(id) {
  return cachedHttp.get(`${apiEndPoint}/${id}/`);
}

export default getLanguage;
